define('lib/Podio.Transport.SpaceContacts',['require','lib/Podio.Transport','lib/Podio.Routes'],function (require) {

  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');

  function getCreateSpaceContactModalLayout(space_id, callback) {
    var url = routes.new_space_space_contact_path(space_id);
    transport.getJSON(url, {}, callback);
  }

  function createSpaceContact(elmForm, callback) {
    var path = elmForm.attr('action');
    var requestData = elmForm.serializeArray();

    transport.postJSON(path, {'requestData': requestData}, function(responseData) {
      callback(responseData);
    });
  }

  function getUpdateSpaceContactModalLayout(space_id, profile_id, type, callback) {
    var url = routes.edit_space_space_contact_path(space_id, profile_id, {'type': type});
    transport.getJSON(url, {}, callback);
  }

  function updateSpaceContact(elmForm, callback) {
    var path = elmForm.attr('action');
    var requestData = elmForm.serializeArray();

    transport.putJSON(path, {'requestData': requestData}, function(responseData) {
      callback(responseData);
    });
  }

  function deleteSpaceContact(space_id, profile_id, callback) {
    var url = routes.space_space_contact_path(space_id, profile_id);
    transport.deleteJSON(url, {}, function(responseData) {
      callback(responseData);
    });
  }

  return {
    getCreateSpaceContactModalLayout: getCreateSpaceContactModalLayout,
    createSpaceContact: createSpaceContact,
    getUpdateSpaceContactModalLayout: getUpdateSpaceContactModalLayout,
    updateSpaceContact: updateSpaceContact,
    deleteSpaceContact: deleteSpaceContact
  };

});



